/**
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FocusTrapTracker} from './focus-trap-tracker.service';

import {FOCUS_TRAP_DIRECTIVES} from './index';
export class ClrFocusTrapModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    providers: [FocusTrapTracker],
    declarations: [FOCUS_TRAP_DIRECTIVES],
    exports: [FOCUS_TRAP_DIRECTIVES]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrFocusTrapModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrFocusTrapModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrFocusTrapModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
